import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Dubai Business Club",
      subtitle: "Application Only",
      description: "Reales Experten Know-How seit 25 Jahren mit nachweisbaren Erfahrungen",
      image: "https://public.readdy.ai/ai/img_res/4291dc429c80118d2ca1b2527949fcf7.jpg"
    },
    {
      title: "Exklusiver und limitierter Zugang",
      subtitle: "Bewerbungsbasierte Mitgliedschaft",
      description: "Wir prüfen jede Bewerbung sorgfältig und entscheiden individuell über die Aufnahme",
      image: "https://readdy.ai/api/search-image?query=exclusive%20luxury%20golden%20key%20on%20dark%20elegant%20background%20symbolizing%20access%20and%20exclusivity%20premium%20business%20concept%20sophisticated%20lighting&width=1920&height=1080&seq=dbc-hero-2&orientation=landscape"
    },
    {
      title: "Zugang statt Versprechen",
      subtitle: "UAE-Strukturen • Immobilien • Experten-Netzwerk",
      description: "Echte Kontakte, geprüfte Partner und direkte Zugänge zu relevanten Strukturen",
      image: "https://readdy.ai/api/search-image?query=dubai%20marina%20yacht%20club%20luxury%20lifestyle%20exclusive%20networking%20modern%20architecture%20golden%20sunset%20professional%20business%20setting%20elegant%20composition&width=1920&height=1080&seq=dbc-hero-3&orientation=landscape"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative h-screen w-full overflow-hidden bg-black">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt="Dubai Business Club"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          </div>

          {/* Content */}
          <div className="relative h-full flex items-center">
            <div className="container mx-auto px-4 sm:px-6 lg:px-12">
              <div className="max-w-4xl">
                {/* Title */}
                <div className="mb-6 sm:mb-8">
                  <h1 className="font-serif text-white leading-none text-4xl sm:text-6xl md:text-7xl lg:text-9xl mb-3 sm:mb-4">
                    {slide.title}
                  </h1>
                  <div className="w-20 sm:w-32 h-0.5 bg-yellow-600 mt-4 sm:mt-6"></div>
                </div>

                {/* Subtitle */}
                <p className="text-yellow-600 text-base sm:text-xl lg:text-2xl font-light mb-4 sm:mb-6 tracking-wide">
                  {slide.subtitle}
                </p>

                {/* Description */}
                <p className="text-white/70 text-base sm:text-lg lg:text-xl font-light max-w-2xl mb-8 sm:mb-12 leading-relaxed">
                  {slide.description}
                </p>

                {/* CTA */}
                <a
                  href="#bewerbung"
                  className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-black/40 backdrop-blur-md border border-yellow-600/50 text-white rounded-full hover:bg-yellow-600/20 hover:border-yellow-600 transition-all duration-300 group whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  <span className="font-light tracking-wide">Jetzt für Mitgliedschaft bewerben</span>
                  <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Controls */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-4 sm:gap-6 z-20">
        {/* Prev Button */}
        <button
          onClick={prevSlide}
          className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-white/30 rounded-full text-white hover:bg-white/10 hover:border-white/50 transition-all cursor-pointer"
          aria-label="Vorheriger Slide"
        >
          <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
        </button>

        {/* Dots */}
        <div className="flex gap-2 sm:gap-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-1.5 sm:h-2 rounded-full transition-all cursor-pointer ${
                index === currentSlide
                  ? 'w-10 sm:w-12 bg-yellow-600'
                  : 'w-1.5 sm:w-2 bg-white/40 hover:bg-white/60'
              }`}
              aria-label={`Gehe zu Slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-white/30 rounded-full text-white hover:bg-white/10 hover:border-white/50 transition-all cursor-pointer"
          aria-label="Nächster Slide"
        >
          <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
        </button>
      </div>

      {/* Scroll Indicator - Hidden on mobile */}
      <div className="hidden lg:flex absolute bottom-12 right-12 flex-col items-center gap-2 text-white/60">
        <span className="text-xs tracking-widest uppercase rotate-90 origin-center mb-8 font-light">Scroll</span>
        <div className="w-px h-16 bg-white/30"></div>
      </div>
    </div>
  );
}
